import { render, staticRenderFns } from "./appstore3.vue?vue&type=template&id=92b7d78e&"
import script from "./appstore3.vue?vue&type=script&lang=js&"
export * from "./appstore3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports